import { Component, EventEmitter, OnInit, ViewChild, Output } from '@angular/core';
import { NgForm } from '@angular/forms';
import { NotificationService, PagedSearch } from 'src/app/shared';
import { PledgeCampaignDto } from '../../shared/pledge-campaign/dto/pledge-campaign.dto';
import { PledgeCampaignService } from '../../shared/pledge-campaign/pledge-campaign.service';
import { SelectItem } from 'primeng/api';
import { PledgeCampaignTypeSearchDto } from '../../shared/pledge-campaign/dto/pledge-campaign-type-search.dto';
import { PledgeCampaignTypeService } from '../../shared/pledge-campaign/pledge-campaign-type.service';
import { PledgeCampaignTypeDto } from '../../shared/pledge-campaign/dto/pledge-campaign-type.dto';
import { NavigationService } from 'src/app/shared/navigation/navigation.service';

@Component({
  selector: 'wl-pledge-campaigns-add-dialog',
  templateUrl: './pledge-campaigns-add-dialog.component.html',
  styleUrls: ['./pledge-campaigns-add-dialog.component.less'],
    standalone: false
})
export class PledgeCampaignsAddDialogComponent implements OnInit {
  @ViewChild(NgForm) private _form: NgForm;
  @Output() pledgeCampaignSaved = new EventEmitter<PledgeCampaignDto>();

  show = false;
  isSaving = false;
  pledgeCampaign = {} as PledgeCampaignDto;
  pledgeCampaignTypes: SelectItem[] = [];
  pledgeCampaignTypeSearch = new PagedSearch() as PledgeCampaignTypeSearchDto;
  pledgeCampaignYear?: Date;

  constructor(
    private _pledgeCampaignService: PledgeCampaignService,
    private _pledgeCampaignTypeService: PledgeCampaignTypeService,
    private _notificationService: NotificationService,
    private _navigationService: NavigationService
  ) {}

  async ngOnInit(): Promise<void> {
    this._pledgeCampaignTypeService
      .searchPledgeCampaignTypes(this.pledgeCampaignTypeSearch)
      .then((data) => {
        if (data.TotalCount > 0) {
          this.pledgeCampaignTypes = data.Result.map<SelectItem>((x: PledgeCampaignTypeDto) => {
            return { label: x.PledgeCampaignType1, value: x.PledgeCampaignTypeId };
          });
        }
      })
      .catch((err) => {
        this._notificationService.httpError(err);
      });
  }

  public open() {
    this.show = true;
    this.pledgeCampaign.StartDate = new Date();
    this.pledgeCampaign.EndDate = new Date();
  }

  save() {
    this.isSaving = true;
    this.pledgeCampaign.CampaignYear = this.pledgeCampaignYear ? this.pledgeCampaignYear.getFullYear() : this.pledgeCampaign.CampaignYear;
    this._pledgeCampaignService
      .createPledgeCampaign(this.pledgeCampaign)
      .then((pledgeCampaignId: number) => {
        this.pledgeCampaignSaved.emit(this.pledgeCampaign);
        this._notificationService.translateSuccess('common.saved-successfully');
        this.close();
        this._navigationService.navigateToPledgeCampaignEdit(pledgeCampaignId);
      })
      .catch((error) => {
        this._notificationService.httpError(error);
      })
      .finally(() => {
        this.isSaving = false;
        this.pledgeCampaignYear = null;
      });
  }

  close() {
    this.show = false;
    this.pledgeCampaign = {} as PledgeCampaignDto;
  }
}
